import React from 'react';
import PropTypes from 'prop-types';
import { FormattedNumber, FormattedDate, FormattedMessage } from 'react-intl';
import { Field, formValueSelector } from 'redux-form';
import RadioField from '../app-main/components/reduxForms/fields/RadioField/RadioField';
import { BOOKING_REQUEST_FORM } from './forms/constants';
import { connect } from 'react-redux';

const SplitPayments = ({
  intl,
  initialValues,
  fullAmount,
  partialAmount,
  currency,
  onSplitPaymentChange,
  feeAmount,
  partialAmountWithoutFee,
  selectedPaymentOption,
  splitPaymentChargeDate,
  splitPaymentCheckout,
  isProcessing
}) => {
  const payFullSelectedClassName =
    selectedPaymentOption === 'pay_full' ? 'border-black' : 'border';
  const payPartialSelectedClassName =
    selectedPaymentOption === 'pay_partial' ? 'border-black' : 'border';

  /**
   * payFullTotal is a temporary calculation until the backend has fields
   * for this UI. This will be a fast follow after intial release of split payments (See sc-98203)
   */
  const payFullTotal = splitPaymentCheckout
    ? fullAmount - feeAmount
    : fullAmount;

  return (
    <div
      className='SplitPayments margin-xl-bottom margin-lg-top'
      data-testing-id='split-payment-toggle'
    >
      <Field
        className='payment-option margin-lg-bottom heavy'
        initialValues={initialValues}
        component={RadioField}
        onChange={(e, newValue) => onSplitPaymentChange(newValue)}
        name='split_payment'
        isProcessing={isProcessing}
        options={[
          {
            id: 'pay-full',
            value: 'pay_full',
            label: intl.formatMessage({
              id: 'split_payments.pay_in_full',
              defaultMessage: 'Pay in full'
            }),
            className: `${payFullSelectedClassName}`,
            component: (
              <span>
                <FormattedNumber
                  value={payFullTotal}
                  currency={currency}
                  style={'currency'}
                />
              </span>
            ),
            componentClass: 'amount full-amount',
            customComponent: (
              <div className='help-block'>
                <FormattedMessage
                  id='bkc.split_payments.pay_total_now'
                  defaultMessage='Pay the total now.'
                />
              </div>
            )
          },
          {
            id: 'pay-partial',
            value: 'pay_partial',
            label: intl.formatMessage({
              id: 'split_payments.part_now_part_later',
              defaultMessage: 'Pay part now, part later'
            }),
            className: `${payPartialSelectedClassName}`,
            component: <span><FormattedNumber value={partialAmount} currency={currency} style={'currency'} /></span>,
            componentClass: 'amount partial-amount',
            customComponent: <div className="help-block" data-testing-id='pnpl-details'>
              <FormattedMessage
                id="bkc.split_payments.split_payments_explanation"
                defaultMessage="Pay part today, plus a {feeAmountText} setup fee, and the rest ({partialAmountWithoutFeeText}) will be automatically charged to the same payment method on {splitPaymentChargeDateText}."
                values={{
                  feeAmountText: <FormattedNumber value={feeAmount} currency={currency} style="currency" />,
                  partialAmountWithoutFeeText: <FormattedNumber value={partialAmountWithoutFee} currency={currency} style="currency" />,
                  splitPaymentChargeDateText: <FormattedDate value={splitPaymentChargeDate} year="numeric" month="short" day="numeric"/>
                }}/>
            </div>
          }
        ]}
      />
    </div>
  );
};

SplitPayments.propTypes = {
  fullAmount: PropTypes.string,
  partialAmount: PropTypes.string,
  partialAmountWithoutFee: PropTypes.string,
  feeAmount: PropTypes.string,
  initialValues: PropTypes.object,
  currency: PropTypes.string,
  onSplitPaymentChange: PropTypes.func,
  splitPaymentChargeDate: PropTypes.string
};

const selector = formValueSelector(BOOKING_REQUEST_FORM);
const mapStateToProps = (state) => {
  const selectedPaymentOption = selector(state, 'split_payment');
  return { selectedPaymentOption };
};

export default connect(mapStateToProps)(SplitPayments);
